module.exports = __webpack_public_path__ + "static/img/icon_fk.a0f94d31.png";